import {
  buildRequest,
  buildRequestWithAuth,
  errorUnlessOk,
  headersBackendSeguros,
} from "./utils";
import environment from "~libs/environment";

/**
 * Tipos verificados contra el código de los servicios, no asumidos.
 *
 * - Marcas y versiones vienen de mg.vehicles, a través de un proxy passthrough
 *   del backend de seguros que reenvía el body sin transformarlo.
 * - Códigos postales y localidades vienen de Euro.
 *
 * Ambos backends serializan en camelCase, aunque sus contratos estén escritos
 * en PascalCase.
 */

/** Item de la respuesta de versiones de mg.vehicles. */
export interface VersionVehiculo {
  marca: string;
  modelo: string;
  version: string;
  codia: string;
}

export interface GetVersionesResponse {
  total: number;
  items: VersionVehiculo[];
}

export interface GetCodigosPostalesResponse {
  codigosPostales: string[];
}

export interface GetLocalidadesResponse {
  localidades: string[];
}

const vehiculos = () => {
  return {
    getMarcas: async (): Promise<string[]> => {
      const request = buildRequestWithAuth("GET", null, headersBackendSeguros);

      try {
        const response = await fetch(
          `${environment.segurosUrl}/vehicles/marcas`,
          request
        );
        errorUnlessOk(response);
        return await response.json();
      } catch (error) {
        console.error(error);
        throw error;
      }
    },

    getModelos: async (
      marca: string,
      anio: string
    ): Promise<GetVersionesResponse> => {
      const request = buildRequestWithAuth("GET", null, headersBackendSeguros);

      try {
        const response = await fetch(
          `${environment.segurosUrl}/vehicles/marcas/${encodeURIComponent(
            marca
          )}/anios/${encodeURIComponent(anio)}/versiones`,
          request
        );
        errorUnlessOk(response);
        return await response.json();
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
  };
};

const provincias = () => {
  return {
    getCodigosPostales: async (
      provinciaId: string,
      localidad?: string
    ): Promise<GetCodigosPostalesResponse> => {
      const request = buildRequest("GET");

      let finalUrl = `${
        environment.catalogosUrl
      }/provincias/${encodeURIComponent(provinciaId)}/codigospostales`;

      if (localidad) {
        finalUrl += `?localidad=${encodeURIComponent(localidad)}`;
      }

      try {
        const response = await fetch(finalUrl, request);
        errorUnlessOk(response);
        return await response.json();
      } catch (error) {
        console.error(error);
        throw error;
      }
    },

    getLocalidades: async (
      provinciaId: string
    ): Promise<GetLocalidadesResponse> => {
      const request = buildRequest("GET");

      try {
        const response = await fetch(
          `${environment.catalogosUrl}/provincias/${encodeURIComponent(
            provinciaId
          )}/localidades?format=json`,
          request
        );
        errorUnlessOk(response);
        return await response.json();
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
  };
};

export { vehiculos, provincias };
